import CustomCard from '../../../../components/CustomCard';
import {
    IconLogoIEntryComplete,
} from '../../../../components/buttons/IconButtons';
import { STATUS_MODEL} from '../../../../enums/statusEnum';
import EventExternalApp from "./Functionality/EventExternalApp";
import InvitationNotFound from "../../Visitor/External/InvitationNotFound";
import {invitationInTime} from "../../Visitor/Invitation/Model/Model";
import InvitationOverdue from "../../Visitor/External/InvitationOverdue";
import ContainerValidation from "../../Visitor/External/Components/ContainerValidation";
import HeaderValidation from "../../Visitor/External/Components/HeaderValidation";
import BodyValidation from "../../Visitor/External/Components/BodyValidation";
import StatusCard from "../../Visitor/External/StatusCard";
import {Trans} from "react-i18next";
import React from "react";
/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: FullStack
 */
const EventExternal = () => {

    const {
        t,
        getPublicEventDetail,
        visitorStatus,
    } = EventExternalApp();

    return (
        <>
            {(getPublicEventDetail == null ||
                Object.entries(getPublicEventDetail)?.length === 0 ||
                getPublicEventDetail?.approvalStatus?.id !== STATUS_MODEL.APPROVED )?
                <InvitationNotFound trans={getPublicEventDetail === null ? "loading": "reservation_not_found"}/>
                :
                !invitationInTime(getPublicEventDetail?.endDate) ?
                    <InvitationOverdue
                        title={t("this_reservation_is_no_longer_available")}
                        description={<Trans
                            i18nKey={"the_date_associated_with_this_reservation_has_passed"}
                            components={{
                                '<br/>': <br/>,
                            }}
                        />}
                    />
                    :
                    <ContainerValidation>
                        <HeaderValidation
                            showBtnBack={false}
                            headerCenter={<IconLogoIEntryComplete className={'icon-color-primary-800'} height={30} />}
                        />
                        <BodyValidation
                            showBtnNext={false}
                            showBtnPrev={false}
                            showLogoFooter={false}
                            className="identity-invitation-body"
                            classWith="content-center-w-800px gap-2"
                        >
                            <div className="w-100 px-0 d-flex flex-column flex-md-row gap-2">
                                <CustomCard classes="col-12 col-md-10 offset-md-1 mb-64px overflow-hidden" classCard="card-border-8px border-0 p-10px" classContent="p-0">
                                    <StatusCard
                                        classContent={"px-3 py-2 pb-3 overflow-hidden"}
                                        content={{
                                            ...visitorStatus,
                                            HEADER: visitorStatus.HEADER({
                                                id: getPublicEventDetail?.id || null
                                            }),
                                            BODY: visitorStatus.BODY({
                                                id: getPublicEventDetail?.id || null
                                            }),
                                        }}
                                    />
                                </CustomCard>
                            </div>
                        </BodyValidation>
                    </ContainerValidation>
            }
        </>
    )
}

export default EventExternal
